import { CanvasComponent, CanvasContentId } from 'types/canvas';

// Negative IDs are used for components that are not yet saved to the database
export const AVAILABLE_CANVAS_COMPONENTS: Record<
  CanvasContentId,
  CanvasComponent
> = {
  [CanvasContentId.GAMMA_LEVELS_CHART]: {
    id: -1,
    container_id: 0,
    label: 'Gamma Levels Chart',
    contentId: CanvasContentId.GAMMA_LEVELS_CHART,
    type: 'chart',
    position_index: 0,
    config: {
      sym: 'SPX',
    },
  },
  [CanvasContentId.LIVE_PRICES_CHART]: {
    id: -2,
    container_id: 0,
    label: 'Live Prices Chart',
    contentId: CanvasContentId.LIVE_PRICES_CHART,
    type: 'chart',
    position_index: 0,
    config: {
      sym: 'SPX',
    },
  },
  [CanvasContentId.SG_LEVELS]: {
    id: -3,
    container_id: 0,
    label: 'SpotGamma Levels',
    contentId: CanvasContentId.SG_LEVELS,
    type: 'table',
    position_index: 0,
    config: {
      sym: 'SPX',
    },
  },
  [CanvasContentId.INDEX_METRICS]: {
    id: -4,
    container_id: 0,
    label: 'Index Metrics',
    contentId: CanvasContentId.INDEX_METRICS,
    type: 'table',
    position_index: 0,
    config: {
      sym: 'SPX',
    },
  },
  [CanvasContentId.SUPP_RESISTANCE_LEVELS]: {
    id: -5,
    container_id: 0,
    label: 'Support & Resistance Levels',
    contentId: CanvasContentId.SUPP_RESISTANCE_LEVELS,
    type: 'table',
    position_index: 0,
    config: {
      sym: 'SPX',
    },
  },
  [CanvasContentId.INDEX_LEVELS]: {
    id: -6,
    container_id: 0,
    label: 'Index Levels',
    contentId: CanvasContentId.INDEX_LEVELS,
    type: 'table',
    position_index: 0,
    config: {
      sym: 'SPX',
    },
  },
  [CanvasContentId.AT_SPOTGAMMA]: {
    id: -7,
    container_id: 0,
    label: 'At SpotGamma',
    contentId: CanvasContentId.AT_SPOTGAMMA,
    type: 'table',
    position_index: 0,
    config: {
      sym: 'SPX',
    },
  },
  [CanvasContentId.MACRO_ECONOMIC_CALENDAR]: {
    id: -8,
    container_id: 0,
    label: 'Economic Calendar',
    contentId: CanvasContentId.MACRO_ECONOMIC_CALENDAR,
    type: 'list',
    position_index: 0,
    config: {
      sym: 'SPX',
    },
  },
  [CanvasContentId.EARNINGS]: {
    id: -9,
    container_id: 0,
    label: 'Earnings',
    contentId: CanvasContentId.EARNINGS,
    type: 'table',
    position_index: 0,
    config: {
      sym: 'SPX',
    },
  },
  [CanvasContentId.EARNINGS_CHART]: {
    id: -10,
    container_id: 0,
    label: 'Earnings Chart',
    contentId: CanvasContentId.EARNINGS_CHART,
    type: 'chart',
    position_index: 0,
    config: {
      sym: 'SPX',
    },
  },
  [CanvasContentId.SCANNER_SQUEEZE_CANDIDATES]: {
    id: -11,
    container_id: 0,
    label: 'Squeeze Candidates Scanner',
    contentId: CanvasContentId.SCANNER_SQUEEZE_CANDIDATES,
    type: 'table',
    position_index: 0,
    config: {
      sym: 'SPX',
    },
  },
  [CanvasContentId.SCANNER_VRP_CANDIDATES]: {
    id: -12,
    container_id: 0,
    label: 'VRP Candidates Scanner',
    contentId: CanvasContentId.SCANNER_VRP_CANDIDATES,
    type: 'table',
    position_index: 0,
    config: {
      sym: 'SPX',
    },
  },
  [CanvasContentId.OCC_CHART]: {
    id: -13,
    container_id: 0,
    label: 'OCC Chart',
    contentId: CanvasContentId.OCC_CHART,
    type: 'chart',
    position_index: 0,
    config: {
      sym: 'SPX',
    },
  },
  [CanvasContentId.ZERO_DTE_EQUITY_VOL_CHART]: {
    id: -14,
    container_id: 0,
    label: '0DTE Equity Vol Chart',
    contentId: CanvasContentId.ZERO_DTE_EQUITY_VOL_CHART,
    type: 'chart',
    position_index: 0,
    config: {
      sym: 'SPX',
    },
  },
  [CanvasContentId.EQUITY_PUT_CALL_RATIO_CHART]: {
    id: -15,
    container_id: 0,
    label: 'Put/Call Ratio Chart',
    contentId: CanvasContentId.EQUITY_PUT_CALL_RATIO_CHART,
    type: 'chart',
    position_index: 0,
    config: {
      sym: 'SPX',
    },
  },
  [CanvasContentId.EXP_CONCENTRATION_CHART]: {
    id: -16,
    container_id: 0,
    label: 'Expiration Concentration Chart',
    contentId: CanvasContentId.EXP_CONCENTRATION_CHART,
    type: 'chart',
    position_index: 0,
    config: {
      sym: 'SPX',
    },
  },
  [CanvasContentId.GAMMA_MODEL_CHART]: {
    id: -17,
    container_id: 0,
    label: 'Gamma Model Chart',
    contentId: CanvasContentId.GAMMA_MODEL_CHART,
    type: 'chart',
    position_index: 0,
    config: {
      sym: 'SPX',
    },
  },
  [CanvasContentId.COMBO_STRIKES]: {
    id: -18,
    container_id: 0,
    label: 'Combo Strikes Chart',
    contentId: CanvasContentId.COMBO_STRIKES,
    type: 'chart',
    position_index: 0,
    config: {
      sym: 'SPX',
    },
  },
  [CanvasContentId.FIXED_STRIKE_MATRIX]: {
    id: -19,
    container_id: 0,
    label: 'Fixed Strike Matrix',
    contentId: CanvasContentId.FIXED_STRIKE_MATRIX,
    type: 'table',
    position_index: 0,
    config: {
      sym: 'SPX',
    },
  },
  [CanvasContentId.TERM_STRUCTURE]: {
    id: -20,
    container_id: 0,
    label: 'Term Structure Chart',
    contentId: CanvasContentId.TERM_STRUCTURE,
    type: 'chart',
    position_index: 0,
    config: {
      sym: 'SPX',
    },
  },
  [CanvasContentId.VOL_SKEW]: {
    id: -21,
    container_id: 0,
    label: 'Vol Skew Chart',
    contentId: CanvasContentId.VOL_SKEW,
    type: 'chart',
    position_index: 0,
    config: {
      sym: 'SPX',
    },
  },
  [CanvasContentId.VIX_CHART]: {
    id: -22,
    container_id: 0,
    label: 'VIX Chart',
    contentId: CanvasContentId.VIX_CHART,
    type: 'chart',
    position_index: 0,
    config: {
      sym: 'VIX',
    },
  },
  [CanvasContentId.EQUITIES_SCANNER]: {
    id: -23,
    container_id: 0,
    label: 'Equities Scanner',
    contentId: CanvasContentId.EQUITIES_SCANNER,
    type: 'table',
    position_index: 0,
    config: {
      sym: 'SPX',
      scanner: 'volRiskPremium',
    },
  },
  [CanvasContentId.FOUNDERS_NOTES]: {
    id: -24,
    container_id: 0,
    label: "Founder's Notes",
    contentId: CanvasContentId.FOUNDERS_NOTES,
    type: 'rich-text',
    position_index: 0,
    config: {},
  },
  [CanvasContentId.STRATEGY_COMPASS]: {
    id: -25,
    container_id: 0,
    label: 'Compass',
    contentId: CanvasContentId.STRATEGY_COMPASS,
    type: 'chart',
    position_index: 0,
    config: {},
  },
  [CanvasContentId.COMPOSITE_VIEW_CHART]: {
    id: -26,
    container_id: 0,
    label: 'Total OI - Composite View Chart',
    contentId: CanvasContentId.COMPOSITE_VIEW_CHART,
    type: 'chart',
    position_index: 0,
    config: {
      sym: 'SPX',
    },
  },
  [CanvasContentId.SYNTH_COMPOSITE_VIEW_CHART]: {
    id: -30,
    container_id: 0,
    label: 'Synthetic OI - Composite View Chart',
    contentId: CanvasContentId.SYNTH_COMPOSITE_VIEW_CHART,
    type: 'chart',
    position_index: 0,
    config: {
      sym: 'SPX',
    },
  },
  [CanvasContentId.SYNTH_OI_PUT_CALL_IMPACT_CHART]: {
    id: -27,
    container_id: 0,
    label: 'Synthetic OI - Put/Call Impact Chart',
    contentId: CanvasContentId.SYNTH_OI_PUT_CALL_IMPACT_CHART,
    type: 'chart',
    position_index: 0,
    config: {
      sym: 'SPX',
    },
  },
  [CanvasContentId.TOTAL_OI_PUT_CALL_IMPACT_CHART]: {
    id: -28,
    container_id: 0,
    label: 'Total OI - Put/Call Impact Chart',
    contentId: CanvasContentId.TOTAL_OI_PUT_CALL_IMPACT_CHART,
    type: 'chart',
    position_index: 0,
    config: {
      sym: 'SPX',
    },
  },
  [CanvasContentId.FLOW_DATA]: {
    id: -28,
    container_id: 0,
    label: 'Flow Data',
    contentId: CanvasContentId.FLOW_DATA,
    type: 'table',
    position_index: 0,
    config: {},
  },
  [CanvasContentId.TRACE]: {
    id: -29,
    container_id: 0,
    label: 'TRACE',
    contentId: CanvasContentId.TRACE,
    type: 'chart',
    position_index: 0,
    config: {
      sym: 'SPX',
    },
  },
  [CanvasContentId.HIRO_CHART]: {
    id: -30,
    container_id: 0,
    label: 'HIRO',
    contentId: CanvasContentId.HIRO_CHART,
    type: 'chart',
    position_index: 0,
    config: {
      sym: 'S&P 500',
      showPrice: true,
    },
  },
  [CanvasContentId.OPTIONS_CALCULATOR]: {
    id: -31,
    container_id: 0,
    label: 'Options Calculator',
    contentId: CanvasContentId.OPTIONS_CALCULATOR,
    type: 'chart',
    position_index: 0,
    config: {
      sym: 'SPX',
    },
  },
};
